var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8542 7.125H12.6667V5.54165C12.6667 2.48596 10.1807 0 7.125 0C4.06927 0 1.58335 2.48596 1.58335 5.54165V7.125H0.395846C0.177049 7.125 0 7.30205 0 7.52085V17.4167C0 18.2899 0.710088 19 1.58335 19H12.6667C13.5399 19 14.25 18.2899 14.25 17.4167V7.52085C14.25 7.30205 14.073 7.125 13.8542 7.125ZM8.3102 15.3938C8.32256 15.5055 8.28664 15.6176 8.21164 15.7015C8.13664 15.7854 8.02917 15.8333 7.91669 15.8333H6.33335C6.22087 15.8333 6.1134 15.7854 6.0384 15.7015C5.9634 15.6177 5.92744 15.5056 5.93984 15.3938L6.18955 13.1483C5.78405 12.8534 5.54169 12.3868 5.54169 11.875C5.54169 11.0018 6.25178 10.2917 7.12504 10.2917C7.9983 10.2917 8.70838 11.0017 8.70838 11.875C8.70838 12.3868 8.46602 12.8534 8.06053 13.1483L8.3102 15.3938ZM10.2917 7.125H3.95835V5.54165C3.95835 3.79558 5.37893 2.375 7.125 2.375C8.87107 2.375 10.2917 3.79558 10.2917 5.54165V7.125Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLock);
export default __webpack_public_path__ + "static/media/grey-lock.5dc88abea70da6b6503495e4d2b605d1.svg";
export { ForwardRef as ReactComponent };